export default __webpack_public_path__ + "static/media/Download_Button_Google.a5574371.svg";